<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'展示来場状況ダウンロード' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'作成' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="40" style="text-align:center"> No. </th>
      <td mat-cell *matCellDef="let exhibitAttribute; let i = index" style="text-align:right"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell  *matHeaderCellDef [style.width.px]="80" style="text-align:center"> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let exhibitAttribute" [style.width.px]="80" style="text-align:center">
        <button mat-button color="primary" (click)="openEditDialog(exhibitAttribute)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="50" style="text-align:center"> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row" style="text-align:center">
        <mat-checkbox
          color="warn"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="150"> {{'作成日時' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile" [style.width.px]="150"> {{ downloadFile.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="event_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'イベント' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile">
        {{ getEventName(downloadFile) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="exhibit_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'展示' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile">
        {{ getExhibitName(downloadFile) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="memo">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'メモ' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile"> {{ downloadFile.memo }} </td>
    </ng-container>

    <ng-container matColumnDef="start_date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="150"> {{'開始日時' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile" [style.width.px]="150"> {{ downloadFile.start_date.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="end_date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="150"> {{'終了日時' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile" [style.width.px]="150"> {{ downloadFile.end_date.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="count">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="50" style="text-align:center"> {{'件数' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile" [style.width.px]="50" style="text-align:right"> {{ downloadFile.row_count }} </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell  *matHeaderCellDef [style.width.px]="180" style="text-align:center"> {{'ダウンロード' | translate}} </th>
      <td mat-cell *matCellDef="let downloadFile" [style.width.px]="180" style="text-align:center">
        <button mat-raised-button color="primary" (click)="download(downloadFile)" [disabled]="!downloadFile.download_url">{{'ダウンロード' | translate}}</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>
